<template>
    <b-modal id="vincularRtaModal" title="Vincular Gatilhos a RTA Existente" size="xl" hide-footer>
        <p class="mb-3">
            <strong>{{ selectedTriggersCount }}</strong> gatilho(s) selecionado(s) - <span class="orange">Selecione a RTA para vincular</span>
        </p>

        <div class="filters-row mb-3">
            <b-form-input
                v-model="filterRtaCode"
                placeholder="Código RTA"
                size="sm"
                class="filter-input">
            </b-form-input>
            <b-form-select
                v-model="filterProcessId"
                :options="processOptions"
                size="sm"
                class="filter-input">
            </b-form-select>
            <b-form-select
                v-model="filterStatus"
                :options="statusOptions"
                size="sm"
                class="filter-input">
            </b-form-select>
            <b-button variant="outline-secondary" size="sm" @click="resetFilters">
                Limpar
            </b-button>
        </div>

        <div class="table-container">
            <b-table
                v-if="filteredRtas.length > 0"
                :items="filteredRtas"
                :fields="rtaModalTableFields"
                striped
                hover
                responsive
                small
                class="modal-table">

                <template #cell(selecionar)="row">
                    <b-form-radio
                        v-model="selectedRtaId"
                        :value="row.item.id"
                        name="selected-rta">
                    </b-form-radio>
                </template>
            </b-table>

            <div v-else class="text-center py-4">
                <p>Nenhuma RTA disponível para vinculação.</p>
            </div>
        </div>

        <div class="mt-3 d-flex justify-content-between">
            <b-button variant="secondary" @click="cancelar">
                Cancelar
            </b-button>
            <b-button class="orange-btn" @click="confirmar">
                Confirmar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "VincularRtaModal",
    props: {
        selectedTriggersCount: {
            type: Number,
            default: 0
        },
        availableRtas: {
            type: Array,
            default: () => []
        },
        processOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectedRtaId: null,
            filterRtaCode: '',
            filterProcessId: null,
            filterStatus: null
        };
    },
    computed: {
        rtaModalTableFields() {
            return [
                { key: 'selecionar', label: 'Selecionar', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: '5%' } },
                { key: 'rtaCode', label: 'Código RTA', sortable: true, thStyle: { width: '10%' } },
                { key: 'indicatorName', label: 'Indicador', sortable: true, thStyle: { width: '15%' } },
                { key: 'processName', label: 'Processo', sortable: true, thStyle: { width: '15%' } },
                { key: 'responsibleName', label: 'Responsável', sortable: true, thStyle: { width: '15%' } },
                { key: 'creationDate', label: 'Data Abertura', sortable: true, thStyle: { width: '10%' } },
                { key: 'deadline', label: 'Prazo', sortable: true, thStyle: { width: '10%' } },
                { key: 'statusName', label: 'Status', sortable: true, thStyle: { width: '10%' } },
            ];
        },
        statusOptions() {
            return [
                { value: null, text: 'Todos os Status' },
                { value: 'Abertas', text: 'Abertas' },
                { value: 'Em Análise', text: 'Em Análise' },
                { value: 'Análise em Atraso', text: 'Análise em Atraso' },
                { value: 'Em Ações', text: 'Em Ações' },
                { value: 'Ações em Atraso', text: 'Ações em Atraso' }
            ];
        },
        filteredRtas() {
            let filtered = this.availableRtas;

            if (this.filterRtaCode) {
                const searchTerm = this.filterRtaCode.toLowerCase();
                filtered = filtered.filter(rta =>
                    rta.rtaCode.toLowerCase().includes(searchTerm)
                );
            }

            if (this.filterProcessId) {
                filtered = filtered.filter(rta => {
                    return Number(rta.processId) === Number(this.filterProcessId);
                });
            }

            if (this.filterStatus) {
                filtered = filtered.filter(rta => rta.statusName === this.filterStatus);
            }

            return filtered;
        }
    },
    methods: {
        cancelar() {
            this.selectedRtaId = null;
            this.$bvModal.hide('vincularRtaModal');
            this.$emit('cancelar');
        },
        confirmar() {
            this.$emit('confirmar', this.selectedRtaId);
        },
        resetFilters() {
            this.filterRtaCode = '';
            this.filterProcessId = null;
            this.filterStatus = null;
        }
    }
};
</script>

<style scoped>
.filters-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
}

.filter-input {
    max-width: 200px;
    flex: 1;
}

.table-container {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
}

.modal-table {
    font-size: 0.85rem;
}

::v-deep(.modal-table thead th) {
    background-color: #004747;
    color: #fff;
    font-weight: 600;
    border: none;
    padding: 0.5rem;
}

.modal-table tbody td {
    padding: 0.4rem;
    vertical-align: middle;
}

.modal-table tbody tr:hover {
    background-color: #f0f8f8;
}

.orange {
    color: #ff5f00;
    font-weight: 500;
}

::v-deep(.custom-control-input:checked ~ .custom-control-label::after) {
    background-color: #ff5f00;
    border-radius: 100%;
}


::v-deep(.custom-control-input:focus ~ .custom-control-label::before) {
    box-shadow: 0 0 0 0.2rem rgba(255, 95, 0, 0.35);
    border-color: #ff5f00;
}

orange-btn{
    background-color: #ff5f00;
    border-color: #ff5f00;
    color: #fff;
}
</style>
